import QRCode from "react-qr-code";
const Qr=({
    datos='',  setMesgError='', token=''
})=>{                           
    return (
        <>
        {datos  &&
        <div className="w-full p-4">
            <QRCode
                size={800}
                style={{ height: "400", maxWidth: "100%", width: "100%" }}
                value={datos}
                viewBox={`0 0 256 256`}
            />            
            </div>
        }
        </>
    )
}
export default Qr;
